var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{staticClass:"ilab-tabs",attrs:{"value":_vm.value,"animated":false},on:{"on-click":_vm.onTabsClick}},_vm._l((_vm.tabPanes),function(item){return _c('TabPane',{key:item.name,attrs:{"label":item.label,"name":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }